(function () {
    class ManageLandingPageWizard {
        constructor(
            $scope,
            $state,
            $uibModal,
            moment,
            notify,
            ErrorService,
            LandingPagesService,
            BrandsService
        ) {
            this._state = $state;
            this.notify = notify;
            this.moment = moment;
            this._uibModal = $uibModal;
            this.errorService = ErrorService;
            this.landingPagesService = LandingPagesService;
            this.brandsService = BrandsService;

            this.pageId = $state.params.pageId;
            this.brandId = $state.params.brandId;

            this.fetch();
        }

        getPlacementState() {
            return {

                showOnHome: this.showOnHomeScreen
            }
        }

        publish() {
            this.landingPagesService.publishLandingPage(
                this.pageId,
                this.getPlacementState())
                .then(() => {
                    this.notify.success('Published successfully')
                    this._state.go("app.landingpages", this._state.params)
                }).catch((error) => {
                this.errorService.showError(
                    "Oops! there was an issue publishing this landing page. Please try again",
                    error)
            })
        }

        save() {
            this.landingPagesService.updatePlacement(
                this.pageId,
                this.getPlacementState())
                .then(() => {
                    this.notify.success('Saved successfully')
                    this._state.go("app.landingpages", this._state.params)
                })
                .catch((error) => {
                    this.errorService.showError(
                        "Oops! there was an issue saving this landing page. Please try again",
                        error)
                })
        }

        previousStep() {
            this._state.go("app.landingpages.template", this._state.params)
        }

        getOrdinal(n) {
            let ord = 'th';
            if (n % 10 === 1 && n % 100 !== 11) {
                ord = 'st';
            } else if (n % 10 === 2 && n % 100 !== 12) {
                ord = 'nd';
            } else if (n % 10 === 3 && n % 100 !== 13) {
                ord = 'rd';
            }
            return n + ord;
        }

        changeDisplayOrder() {
            const templateUrl = "components/landingpages/wizard/step-3/displayordermodal/displayordermodal.5410e608.html";
            const instance = this._uibModal.open({
                animation: true,
                templateUrl,
                controller: "displayOrderModal",
                backdrop: 'static',
                resolve: {
                    id: () => this.landingPage.Id,
                    title: () => this.landingPage.Title,
                    resourceId: () => this.landingPage.ResourceId,
                    displayOrder: () => this.landingPage.DisplayOrder,
                    brandId: () => this.brandId
                }
            })
            instance.result.then(() => {
                this.fetch()
            })
        }

        copyToClipboard(text) {
            void navigator.clipboard.writeText(text).finally(() => {
                this.notify.success('URL Copied');
            });
        }

        fetch() {
            this.brandsService.fetchBrandById(this.brandId)
                .then((brand) => {
                    this.previewHost = `https://${ brand.CustomerFacingUrl }`;
                    this.landingPagesService.fetchLandingPageById(this.pageId)
                        .then((data) => {
                            this.landingPage = data;
                            this.displayOrder = data.DisplayOrder;
                            this.showOnHomeScreen = data.ShowOnHome;
                            this.liveUrl = `${ this.previewHost }/campaign/${ data.CardGuid }`;
                            this.previewUrl = `${ this.liveUrl }/preview`;
                            this.showPublishButton = !Boolean(data.PublishedAt);
                            this.isPublished = Boolean(data.PublishedAt);
                            this.updateButtonText();
                        })
                        .catch((error) => {
                            this.errorService.showError("There was an issue loading this page", error);
                        });
                })
                .catch((error) => {
                    this.errorService.showError("There was an issue loading the brand detail", error);
                });
        }

        updateButtonText() {
            this.saveButtonText = this.isPublished
                ? "Save"
                : "Save as draft";
        }
    }

    angular
        .module('dashboard')
        .component('placementDetails', {
            templateUrl: 'components/landingpages/wizard/step-3/placement-details.6e0fa182.html',
            controller: [
                '$scope',
                '$state',
                '$uibModal',
                'moment',
                'notify',
                'ErrorService',
                'LandingPagesService',
                'BrandsService',
                ManageLandingPageWizard ]
        });
})();
